import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Screen\GetScreenByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenByIdController.php
* @route '/api/screen-settings/{screen}'
*/
const GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778 = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778.url(args, options),
    method: 'get',
})

GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778.definition = {
    methods: ["get","head"],
    url: '/api/screen-settings/{screen}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenByIdController.php
* @route '/api/screen-settings/{screen}'
*/
GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778.url = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screen: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screen: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screen: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screen: typeof args.screen === 'object'
        ? args.screen.id
        : args.screen,
    }

    return GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778.definition.url
            .replace('{screen}', parsedArgs.screen.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenByIdController.php
* @route '/api/screen-settings/{screen}'
*/
GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778.get = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenByIdController.php
* @route '/api/screen-settings/{screen}'
*/
GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778.head = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenByIdController.php
* @route '/api/screen/{screen}'
*/
const GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5 = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5.url(args, options),
    method: 'get',
})

GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5.definition = {
    methods: ["get","head"],
    url: '/api/screen/{screen}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Screen\GetScreenByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenByIdController.php
* @route '/api/screen/{screen}'
*/
GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5.url = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { screen: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { screen: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            screen: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        screen: typeof args.screen === 'object'
        ? args.screen.id
        : args.screen,
    }

    return GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5.definition.url
            .replace('{screen}', parsedArgs.screen.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Screen\GetScreenByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenByIdController.php
* @route '/api/screen/{screen}'
*/
GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5.get = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Screen\GetScreenByIdController::__invoke
* @see app/Http/Controllers/Screen/GetScreenByIdController.php
* @route '/api/screen/{screen}'
*/
GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5.head = (args: { screen: string | number | { id: string | number } } | [screen: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5.url(args, options),
    method: 'head',
})

/**
* Multiple routes resolve to \App\Http\Controllers\Screen\GetScreenByIdController::GetScreenByIdController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `GetScreenByIdController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const GetScreenByIdController = {
    '/api/screen-settings/{screen}': GetScreenByIdControllerf90a787eb6596c04fddf6ff5763f9778,
    '/api/screen/{screen}': GetScreenByIdControllerdbbb5d103a3873b3ca1bf2cc425f78f5,
}

export default GetScreenByIdController